import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";

import Table from "../../../../components/ui/Table";
import usePagination from "../../../../hooks/usePagination";
import { GM_CAPPERS_COLUMNS } from "../../../ComplianceSearch/constants";
import { appendSearchParamsToQuery } from "../../../ComplianceSearch/utils";
import { COMPLIANCE_API_URLS, ComplianceAPI } from "../../../../api/compliance";
import { fundedComplianceProfileActions } from "../../../../reducers/fundedComplianceProfile";

const GauntCappers: React.FC = () => {
  const dispatch = useDispatch();
  const pagination = usePagination(10);
  const params: { id: string } = useParams();

  const search = { compliance_entries_id: params.id };
  const { data, isLoading } = useSelector((state) => state.fundedComplianceProfile.gauntCappers);

  const { isError, error } = useQuery({
    queryKey: [COMPLIANCE_API_URLS.getGMCappers, params.id, pagination.page, pagination.limit],
    async queryFn({ signal }) {
      const query = new URLSearchParams();
      query.append("limit", pagination.limit.toString());
      query.append("page", pagination.page.toString());
      appendSearchParamsToQuery(search, query);

      dispatch(fundedComplianceProfileActions.fetchGauntCappersRequest());

      const response = await ComplianceAPI.getGMCappersRequest(query.toString(), signal);
      pagination.setCount(response.data.results.count);

      dispatch(fundedComplianceProfileActions.fetchGauntCappersSuccess(response.data.results));

      return response;
    },
  });

  useEffect(() => {
    if (isError && error) {
      console.error("Error fetching Gaunt Cappers", error);
      dispatch(fundedComplianceProfileActions.fetchGauntCappersFailed());
    }
  }, [isError, error]);

  return (
    <Table
      columns={GM_CAPPERS_COLUMNS}
      data={data.rows}
      loading={isLoading}
      pagination={pagination}
      extractKey={(row) => row.id}
      theadTitle="Gaunt Cappers"
      csv_table_name={`Gaunt Cappers entry ID: ${params.id}`}
      noResultsMessage="There are no Gaunt Cappers records"
    />
  );
};

export default GauntCappers;
